import { AutogenLayoutEdiStopQuickInfo } from "./autogen/AutogenLayoutEdiStopQuickInfo";

export class EdiStopShowasQuickInfo extends AutogenLayoutEdiStopQuickInfo {
    
}